import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Shell, inputCls, btnCls } from "@/pages/Login";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If an account exists, a 6-digit code was sent.");
      setStep(2);
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, code, password });
      toast.success("Password updated — please log in.");
      nav("/login");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <Shell title="Reset password" subtitle={step === 1 ? "Enter your email to get a 6-digit code" : "Enter the code and your new password"}>
      {step === 1 ? (
        <form onSubmit={request} className="space-y-4">
          <input data-testid="forgot-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputCls} />
          <button data-testid="forgot-submit" disabled={loading} className={btnCls}>{loading ? "Sending…" : "Send reset code"}</button>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-4">
          <input data-testid="reset-code" placeholder="6-digit code" value={code} onChange={(e) => setCode(e.target.value)} required maxLength={6} className={`${inputCls} font-mono tracking-[0.4em] text-center`} />
          <input data-testid="reset-password" type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className={inputCls} />
          <button data-testid="reset-submit" disabled={loading} className={btnCls}>{loading ? "Updating…" : "Update password"}</button>
          <button type="button" onClick={() => setStep(1)} className="w-full text-slate-400 text-sm">Back</button>
        </form>
      )}
      <p className="text-center text-sm mt-4 text-slate-400"><Link to="/login" className="text-gold">Back to login</Link></p>
    </Shell>
  );
}
